import * as JsSearch from "js-search";
export const rebuildIndex = (searchData: any) => {
  const dataToSearch = new JsSearch.Search(["title", "tags"]);
  dataToSearch.indexStrategy = new JsSearch.PrefixIndexStrategy();

  dataToSearch.sanitizer = new JsSearch.LowerCaseSanitizer();
  dataToSearch.searchIndex = new JsSearch.TfIdfSearchIndex(["title", "tags"]);

  dataToSearch.addIndex("title");
  dataToSearch.addIndex("description");
  dataToSearch.addIndex("tags");

  dataToSearch.addDocuments(searchData);
  return dataToSearch;
};
